import { isAllowed } from '@ion/api/Apollo/allower';
import permissions from '@ion/api/Apollo/permissions';

export function isAllowedToInviteUser() {
  return isAllowed(permissions.createUsers);
}
